<section class="contactoForm">
  <form
    [formGroup]="contactoForm"
    (ngSubmit)="saveContacto(contactoForm.value)"
  >
    <div class="form-body">
      <div class="row">
        <mat-form-field class="col-12 col-md-6">
          <mat-label>Correo Electrónico</mat-label>
          <input
            matInput
            type="email"
            formControlName="correoElectronico"
            placeholder="Correo Electrónico"
            required
          />
          <mat-error *ngIf="hasError('correoElectronico', 'required')">
            *Campo requerido
          </mat-error>
          <mat-error *ngIf="hasError('correoElectronico', 'email')">
            *No es un correo valido
          </mat-error>
        </mat-form-field>

        <mat-form-field class="col-12 col-md-6">
          <mat-label>Motivo de Contacto</mat-label>
          <mat-select
            matInput
            formControlName="motivo"
            placeholder="Motivo de Contacto"
            required
          >
            <mat-option value="Comentario">Comentario</mat-option>
            <mat-option value="Sugerencia">Sugerencia</mat-option>
            <mat-option value="Duda">Duda</mat-option>
            <mat-option value="Pregunta">Pregunta</mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('motivo', 'required')">
            *Campo requerido
          </mat-error>
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field class="col-12">
          <mat-label>Mensaje</mat-label>
          <textarea
            matInput
            formControlName="mensaje"
            placeholder="Deja aquí tu mensaje"
            required
          ></textarea>
          <mat-error *ngIf="hasError('mensaje', 'required')">
            *Campo requerido
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <div class="text-right">
          <button
            mat-raised-button
            type="submit"
            class="btn-blue-cat"
            [disabled]="!contactoForm.valid"
          >
            Enviar
          </button>
        </div>
      </div>
    </div>
  </form>
</section>

<section class="mt-3" *ngIf="error">
  <div
    class="alert alert-danger alert-dismissible fade show mb-0 alert-text"
    role="alert"
  >
    ERROR: Error al enviar tus datos.
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</section>

<section class="mt-3" *ngIf="success" #successAlert>
  <div
    class="alert alert-success alert-dismissible fade show mb-0 alert-text"
    role="alert"
  >
    ¡Tus datos han sido enviados exitosamente! Gracias por su contribución.
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</section>
